import { render } from "./simpleCalendar.vue?vue&type=template&id=1c34264a&scoped=true"
import script from "./simpleCalendar.vue?vue&type=script&lang=js"
export * from "./simpleCalendar.vue?vue&type=script&lang=js"

import "./simpleCalendar.vue?vue&type=style&index=0&id=1c34264a&scoped=true&lang=css"
import "./simpleCalendar.vue?vue&type=style&index=1&id=1c34264a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c34264a"]])

export default __exports__